/**
 * Notifications Service
 * API calls for notifications management
 */

import { api } from './api'

export interface Notification {
  id: number
  user_id: number
  type: 'info' | 'warning' | 'error' | 'success'
  category: 'api_key' | 'bot' | 'system' | 'report'
  title: string
  message: string
  severity: 'low' | 'medium' | 'high' | 'critical'
  is_read: number
  sent_email: number
  related_entity_type: string | null
  related_entity_id: number | null
  created_at: number
  read_at: number | null
}

export interface ListNotificationsResponse {
  notifications: Notification[]
  pagination: {
    total: number
    limit: number
    offset: number
  }
  unread_count: number
}

export interface ListNotificationsParams {
  is_read?: 'true' | 'false' | 'all'
  category?: 'api_key' | 'bot' | 'system' | 'report'
  limit?: number
  offset?: number
}

/**
 * List notifications with filtering and pagination
 */
export async function listNotifications(
  params: ListNotificationsParams = {}
): Promise<ListNotificationsResponse> {
  const queryParams: Record<string, string> = {}

  if (params.is_read) queryParams.is_read = params.is_read
  if (params.category) queryParams.category = params.category
  if (params.limit) queryParams.limit = params.limit.toString()
  if (params.offset) queryParams.offset = params.offset.toString()

  return api.get<ListNotificationsResponse>('/notifications', queryParams)
}

/**
 * Mark notification as read
 */
export async function markNotificationAsRead(id: number): Promise<{ success: boolean }> {
  return api.patch<{ success: boolean }>(`/notifications/${id}/read`)
}

/**
 * Delete single notification
 */
export async function deleteNotification(id: number): Promise<{ success: boolean }> {
  return api.delete<{ success: boolean }>(`/notifications/${id}`)
}

/**
 * Mark all notifications as read
 */
export async function markAllAsRead(): Promise<{ success: boolean; count: number }> {
  return api.post<{ success: boolean; count: number }>('/notifications/mark-all-read')
}

/**
 * Delete all read notifications
 */
export async function deleteAllRead(): Promise<{ success: boolean; count: number }> {
  return api.delete<{ success: boolean; count: number }>('/notifications/delete-all-read')
}
